const userData = {
  Name: "Jatin Besoya",
  CVUrl: "#",
  LinkedinUrl: "https://www.linkedin.com/in/jatin-besoya-0523171b9",
  GithubUrl: "https://github.com/jagdishdev32/",
  // ProjectsUrl: "https://bk.jagdish-dev.xyz/projects",
  // ProjectsUrl: "http://localhost:5000/projects",
  // ContactFormUrl: "https://bk.jagdish-dev.xyz/contact",
  // ContactFormUrl: "http://localhost:5000/contact",
  API_URL: "",
};

export const projectsData = [
  {
    _id: 4,
    name: "Bookstore",
    description:
      "Bookstore Website with Auth for Employees for adding books or checking books transactions and users auth for buying books (backend with unit testing)",
    url: "https://jagdishdev32.github.io/bookstore-frontend",
  },
  {
    _id: 0,
    name: "Social Web App",
    description:
      "Social Media App with Many great features like Role Based Access Controll, Find Friends , View profile, Posts creation and many more.",
    url: "https://jagdish-social.herokuapp.com/",
  },
  {
    _id: 1,
    name: "Reponsive Portfolio",
    description:
      "Portfolio created with pure Html5, CSS3, Vanilla JavaScript with fully responsive design, many more features.",
    url: "https://jagdish-portfolio-1.netlify.app/",
  },
  {
    _id: 2,
    name: "BrainBread",
    description:
      "BrainBread Blogging Wordpress site clone design created with Pure HTML, CSS, JavaScript",
    url: "https://jagdish-brainbread-clone.netlify.app/",
  },
  {
    _id: 3,
    name: "Apple Scrolling Animation",
    description:
      "Apple IPOD Pro Ad scrolling animation try with pure html, css and javascript",
    url: "https://jagdish-apple-earpodes-v3.netlify.app/",
  },
];

export default userData;
